import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";

function TVMenuAddUpdate() {

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/tv_side_menu/edit`
    const storeApi = `${baseURL}/admin/tv_side_menu/store`
    const imageApi = globalImageUplaodAPI()
    const updateApi = `${baseURL}/admin/tv_side_menu/update`

    const navigate = useNavigate()
    const { id } = useParams()
    const combinedRef = useRef({});
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({ name: "" });
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [lightImageFile, setLightImageFile] = useState('');


    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "TV Menu Name cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
        else {
            console.table("validation")
        }
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            const imageFields = [];
            if (name == 'icon') {
                formDataAdd.append('image', lightImageFile)
                formDataAdd.append('id', id);
                formDataAdd.append('modelName', 'TvSideMenu');
                imageFields.push('image')
                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            setLightImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "short_note", "active"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                if (lightImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                navigate("/tvmenu")
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "short_note", "active"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                if (lightImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type == "text" || type === 'select-one' || type == "textarea") {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: value,
            }));
        }
        setFormDataError((prevEditUser) => ({
            ...prevEditUser,
            [name]: '',
        }));
    }

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);
            if (name == 'light') {
                setLightImageFile(newFile);
            };
        }
    }

    const handleClearSelectFile = (value) => {
        if (value == 'light') {
            setLightImageFile(null)
        }
    }

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }

    useEffect(async () => {
        if (id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.tv_side_menus,
                        }));
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
    }, [withOutRefresh]);

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && <Response_Processing></Response_Processing>}
            {<AdminBackNavigation path={`${'/tvmenu'}`} text="Back" />}
            <AdminSaveHeader heading={id ? "Edit TV Menu" : "Add TV Menu"} saveText={id ? "Update TV Menu" : "Save TV Menu"} saveMethod={handleStore} loading={showOverlay} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={id ? "Update Menu" : "Create Menu"} />
                        <MessageLabel text="TV Menu Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Enter name"} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Menu Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text='Menu Icon' />
                        <MessageLabel text="TV Menu image" />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={lightImageFile}
                            uploadedImage={formData?.image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="light"
                            id={id}
                            error={formDataError?.image}
                        />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update TV Menu" : "Save TV Menu"} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </>
    );
}
export default TVMenuAddUpdate;
